import * as React from 'react';

var _circle, _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgLoadOwnerIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    fill: "#E1EAFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "load_owner_icon_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 65,
    height: 65
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 32.5C65 50.45 50.45 65 32.5 65S0 50.45 0 32.5 14.55 0 32.5 0 65 14.55 65 32.5z",
    fill: "#E1EAFF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#load_owner_icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.648 53.159l-11.553 3.837v23.02L9.648 76.18V53.159z",
    fill: "#D3914F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-25 56.996l11.542-3.837H9.648l-11.553 3.837H-25z",
    fill: "#F1D392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.422 38.705H2.602v34.692h34.82V38.705z",
    fill: "#E5B571"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.826 32.921L37.42 38.705v34.692l17.405-5.784V32.92z",
    fill: "#CE8D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.601 38.705l17.405-5.784h34.82l-17.404 5.784H2.602z",
    fill: "#ECCF8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.72 61.91v9.677l5.209-1.684V60.18l-5.208 1.73zM42.72 36.941v9.667l5.209-1.684v-9.712l-5.208 1.73z",
    fill: "#C07632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.12 35.212l-.725.24-1.092.355-3.644 1.134h35.062l5.208-1.73h-34.81z",
    fill: "#CE8D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.916 40.916H24.098v5.096h11.818v-5.096z",
    fill: "#E4E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 41.397h-.23v4.02h.23v-4.02zM26.121 41.397h-.23v4.02h.23v-4.02zM26.742 41.397h-.23v4.02h.23v-4.02zM27.374 41.397h-.23v4.02h.23v-4.02z",
    fill: "#5B5C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.397 41.397h-.23v4.02h.23v-4.02zM28.018 41.397h-.23v4.02h.23v-4.02zM28.639 41.397h-.23v4.02h.23v-4.02zM29.27 41.397h-.229v4.02h.23v-4.02zM29.662 41.397h-.23v4.02h.23v-4.02zM30.26 41.397h-.23v4.02h.23v-4.02zM30.869 41.397h-.23v4.02h.23v-4.02zM31.49 41.397h-.23v4.02h.23v-4.02zM32.122 41.397h-.23v4.02h.23v-4.02zM32.743 41.397h-.23v4.02h.23v-4.02z",
    fill: "#5B5C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.766 41.397h-.23v4.02h.23v-4.02zM33.386 41.397h-.23v4.02h.23v-4.02zM34.019 41.397h-.23v4.02h.23v-4.02zM34.64 41.397h-.23v4.02h.23v-4.02z",
    fill: "#5B5C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.904 14.871H9.636v23.181h23.268v-23.18z",
    fill: "#F8C47A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.537 11l-11.633 3.871v23.17l11.633-3.86V11z",
    fill: "#E19A54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.636 14.871L21.27 11h23.267l-11.633 3.871H9.636z",
    fill: "#FFDF9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.191 37.044h-7.15v-3.607h7.15v3.607zm-7.058-.103h6.955v-3.413h-6.955v3.413z",
    fill: "#9F5B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.306 37.148h-7.369v-3.826h7.369v3.825zm-7.058-.31h6.748v-3.207h-6.748v3.207z",
    fill: "#9F5B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.052 35.934v-1.375h.31l-.39-.39-.39.39h.31v1.375h.16zM26.926 35.934v-1.375h.322l-.39-.39-.392.39h.31v1.375h.15zM27.03 36.07H25.8v.104h1.23v-.103zM29.582 34.834c-.035-.378-.391-.664-.84-.664-.448 0-.816.297-.839.664h1.69-.011z",
    fill: "#9F5B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.64 34.891h-1.806v-.057c.035-.4.426-.71.897-.71.471 0 .862.31.897.71v.057h.011zm-1.68-.103h1.564c-.057-.32-.39-.561-.782-.561-.39 0-.724.24-.781.561z",
    fill: "#9F5B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.903 36.117s-.103-.023-.138-.058c-.08-.08-.069-.206-.069-.229v-1.042s.023-.046.046-.046.046.023.046.046v1.042s0 .115.046.15c.012.01.035.022.07.022.034 0 .045-.011.057-.023.034-.034.034-.126.023-.149 0-.023.011-.057.046-.057.023 0 .057.011.057.046 0 .011.023.149-.046.229a.185.185 0 01-.126.057l-.012.012z",
    fill: "#9F5B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.903 36.174a.234.234 0 01-.172-.069c-.092-.091-.092-.24-.092-.263V34.8s.046-.103.103-.103c.058 0 .104.045.104.103v1.042s0 .092.034.114h.035c.011-.023.023-.08.011-.103 0-.023 0-.057.023-.08.012-.023.035-.034.07-.046.057 0 .103.035.114.08 0 .023.023.172-.057.275a.245.245 0 01-.173.08v.012zM31.065 35.659a.588.588 0 01-.587-.584v-.814h1.161v.813c0 .321-.264.585-.586.585h.012zm-.483-1.295v.71c0 .264.218.482.483.482a.485.485 0 00.482-.481v-.71h-.965z",
    fill: "#9F5B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.122 35.613h-.103v.538h.103v-.538z",
    fill: "#9F5B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.582 36.105h-1.035v.103h1.035v-.103z",
    fill: "#9F5B48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.904 16.337h-7.898v3.402h7.898v-3.402z",
    fill: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.937 16.67h-.15v2.68h.15v-2.68zM25.351 16.67h-.15v2.68h.15v-2.68zM25.765 16.67h-.15v2.68h.15v-2.68zM26.19 16.67h-.15v2.68h.15v-2.68z",
    fill: "#6D6E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.202 16.67h-.15v2.68h.15v-2.68zM26.616 16.67h-.15v2.68h.15v-2.68zM27.03 16.67h-.15v2.68h.15v-2.68zM27.455 16.67h-.15v2.68h.15v-2.68zM27.72 16.67h-.15v2.68h.15v-2.68zM28.122 16.67h-.15v2.68h.15v-2.68zM28.524 16.67h-.15v2.68h.15v-2.68zM28.938 16.67h-.15v2.68h.15v-2.68zM29.363 16.67h-.15v2.68h.15v-2.68zM29.777 16.67h-.15v2.68h.15v-2.68z",
    fill: "#6D6E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.788 16.67h-.15v2.68h.15v-2.68zM30.214 16.67h-.15v2.68h.15v-2.68zM30.628 16.67h-.15v2.68h.15v-2.68zM31.041 16.67h-.149v2.68h.15v-2.68z",
    fill: "#6D6E71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.88 11l-9.622 3.871h4.024L32.616 11H28.88zM19.258 14.871v4.478h3.99l.034-4.478h-4.024zM19.258 33.689v4.478h3.99l.034-4.478h-4.024z",
    fill: "#CE8D4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.676 33.645a15.124 15.124 0 00-1.65-.25l.095-3.632c.035-1.107-1.14-1.989-2.659-1.965-1.46.024-2.73.953-2.753 2.06l-.095 3.632c-.665.096-1.27.215-1.828.381l.048 3.323h8.901l-.047-3.537-.012-.012z",
    fill: "#F4906E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.316 44.684c-.427-5.704-1.116-6.716-2.659-8.455-1.365-1.536-4.533-2.31-6.04-2.596v-.06c-.44-1.261-1.544-1.202-1.544-1.202-.273 2.036-2.694 2.644-2.694 2.644-2.207-.798-2.73-2.215-2.73-2.215-.866 0-1.388.667-1.566.94-2.564.143-4.854 1.167-6.314 2.763-1.887 2.084-2.54 4.644-2.742 7.776.119.024 2.718 1.06 4.107 1.322-.297 4.287-.594 9.788-.368 12.015.047.43.617.93.688 1.072.712 1.37 17.625 1.179 17.66.084 0-.191.641-.667.677-1.037.166-2.322.119-7.561 0-12.313 1.412-.262 2.837-.714 3.525-.75v.012zM34.777 102.26c1.804-20.018 4.95-35.95 5.104-40.416L30.8 60.83c-.629 7.014-2.421 25.103-3.477 40.56 0 0 .866-.488 2.587-.405 1.638.083 3.525 1.107 4.45 1.393 0 0 .369-.119.416-.131v.012zM40.38 102.26c-.618-20.137-.131-35.95-.286-40.404l9.08-1.013c.629 7.014-1.365 25.639-1.4 40.56 0 0-.879-.489-2.588-.405-2.16.095-3.537 1.107-4.463 1.393l-.356-.131h.012z",
    fill: "#333844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.45 64.583c0-.203.024-.405.072-.596l-.25.036s0 .226.024.643c.048-.024.107-.06.154-.083z",
    fill: "#000",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.884 58.855a511.207 511.207 0 00-.344 7.478s5.282.44 11.014.393c3.727-.036 6.896.25 7.145-1.274.214-1.37.38-3.013.51-6.49 0-.155-.118-.274-.273-.262-.925.095-4.094.37-9.055.31-5.46-.072-7.88-.43-8.57-.489-.106 0-.403.227-.415.334h-.012z",
    fill: "#333844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.421 65.023c.428-.285 1.437-.905 1.959-1.381l-.178-.25c-.297.226-1.413.917-1.733 1.143l-.048.488z",
    fill: "#292D35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.869 60.105c-4.76 0-7.715-.214-9.02-.333-.154 0-.261 1.726-.083 1.798 1.388.13 4.344.333 9.091.333 4.166 0 7.655-.238 9.376-.369.155.012.095-1.774-.071-1.774-1.59.119-4.997.333-9.305.333l.012.012z",
    fill: "#1C1D1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.656 62.522l-1.092-.047.213-3.013 1.08.06-.201 3zM44.652 62.522l-1.092-.047.214-3.013 1.08.06-.202 3z",
    fill: "#333844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.304 64.44l-1.756-1.084c-.072.155-.048.107-.107.274.486.417 1.353.94 1.863 1.262v-.452z",
    fill: "#292D35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.43 52.853c.356-4.18.178-8.288.238-9.145 0-.108-4.522-.846-4.522-.846-.606 5.966-.665 10.539 4.284 9.98v.011zM53.078 42.374s-5.72 1.226-5.708 1.334c.083.821.486 5.263 1.08 9.514 5.044.143 5.518-3.787 4.64-10.848h-.012zM44.628 33.645c-.297.643-1.175 2.489-1.567 2.703-.38.215-1.816-.928-2.409-1.417l-.285.096c-.095-.036-.178-.072-.26-.108-.606.393-1.96 1.25-2.481 1.215-.582-.036-1.318-1.846-1.567-2.382-.107 0-.25.012-.356.024.25.631 1.08 2.763 1.53 3.06.535.346 3.11-1.56 3.11-1.56s2.16 1.918 2.79 1.846c.545-.071 1.519-2.667 1.78-3.405-.095-.024-.202-.036-.285-.06v-.012z",
    fill: "#2E333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.45 59.01l.06-23.96h-.332s0 19.804-.12 23.96h.392z",
    fill: "#2E333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.464 44.648s.392-.071.582-.274c.19-.202.06-.905.06-.905s.177-.392.094-.571c-.095-.179-1.104-.643-1.104-.643s.131-.262.12-.357c-.013-.096-.642-.5-.927-.584-.284-.071-2.338-.19-2.338-.19l.356-2.037h-.38L47.5 41.16s-.19-.5-.498-.488c-.309.012-1.424.762-1.911 1.036-.475.274-2.979 3.513-2.979 3.513s-4.273-1.87-6.017-1.905c-1.745-.036-3.537 1.75-3.537 1.75l.166-5.525h-.38l-.249 6.168s-1.02.762-1.02.87c0 .023-.048.523-.12 1.25-.142 2.262-.26 4.656-.296 6.609.605 0 1.828 0 2.302-.155.653-.214 7.418-2.286 7.418-2.286s5.745 2.75 6.492 2.786c.558.036 2.148-.166 2.98-.274.023-1.881 0-4.168-.036-6.49l-1.52-1.69 1.472-.584v-.31c.463-.083.914-.19 1.353-.297.178-.215.333-.489.333-.489h.011z",
    fill: "#2E333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.412 60.093s-3.288-.036-3.288.024c0 0-.024 1.715 0 1.739.024.023 3.311.023 3.311.023s0 .286-.059.31c-.202.12-3.596.083-3.691 0-.095-.083-.036-2.322.036-2.441.07-.12 3.548-.084 3.608-.036.059.048.07.357.07.357l.013.024z",
    fill: "#5F6163"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.816 60.724s-.036.393-.012.417c.024.024.819 0 .843-.012.023-.012.023-.333 0-.393-.012-.035-.808-.035-.831-.012z",
    fill: "#5F6163"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.462 43.458s.629-.953.736-1.286c.118-.322.368-.346.7-.548.332-.203.724-.5.89-.596.178-.095.665.358.13 1-.533.644-2.456 1.43-2.456 1.43z",
    fill: "#F28C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.718 53.437c.926-.072 2.255-.215 2.445-.43.19-.202.333-.678.344-.737l-.308-.084c-.048.179-.166.5-.273.608-.154.107-1.187.226-2.208.31v.333z",
    fill: "#2E333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.87 46.042c-.95-.227-2.635-.572-3.68 1.44-.676 1.299-.581 2.43 0 3.263 1.009 1.477 3.857 1.858 6.16 1.513 2.896-.44 6.278-1.953 6.278-1.953l2.303-1.548a45.262 45.262 0 01-2.018-1.655c-1.424.166-8.094-.846-9.02-1.06h-.024z",
    fill: "#FF9E78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.38 44.505c-.096-.035-.203-.083-.31-.119.012 2.537.036 5.264.036 7.705.202-.06.309-.095.309-.095l-.036-7.49z",
    fill: "#2E333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.878 47.113c-1.425.167-8.095-.845-9.02-1.06-.95-.226-2.635-.571-3.68 1.441-.676 1.298-.581 2.43 0 3.263 1.01 1.477 3.857 1.858 6.16 1.513 2.896-.441 6.279-1.953 6.279-1.953l2.302-1.548a45.182 45.182 0 01-2.018-1.656h-.023zm-8.439 3.466c-1.092-.108-2.54-.608-2.433-1.81.13-1.5 1.578-1.93 2.706-1.894 1.14.036 5.946 2.68 5.946 2.68s-3.347 1.321-6.219 1.035v-.011z",
    fill: "#DB7D67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.785 43.434s.142-.072.142-.298c0-.226-.249-.381-.605-.5-.356-.12-.653-.238-.653-.238.344-.227.19-.596.06-.62-.131-.023-.63-.214-.914-.297-.285-.072-1.733-.12-2.077-.096-.344.024-.82.31-1.674.727s-1.875 1.215-2.231 1.703c-.368.488-1.116 1.69-1.65 2.036-.474.31-.012.977-1.199 1.227-.035 0-.059 0-.106.011.653.572 1.34 1.108 2.017 1.656l3.739-2.525c.7.107 1.412-.607 1.567-.643.154-.024.38-.262.664-.38.51-.215 1.27-.203 1.816-.346.475-.12.475-.56.475-.56.45-.036.795-.25.807-.512.012-.262-.202-.37-.202-.37l.024.025z",
    fill: "#FF9E78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.708 44.874c-.368.012-.63.036-1.045.262-.498.286-.854.274-1.412.227-.629-.048-1.222-.143-1.851-.167-.44 0-2.078-.226-1.698-1.19-.273.404-1.02 1.44-1.305 1.678-.428.358-.226 1.144-1.4 1.394-.38.083-1.366 0-2.552-.131.308.178.617.357.913.547.914.584 1.793 1.215 2.695 1.834l4.605-3.096c.925.095 1.946-.893 2.23-1.012.511-.215 1.27-.203 1.817-.346a.636.636 0 00.463-.44c-.214.429-1.057.417-1.448.429l-.012.011z",
    fill: "#F28C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.833 43.815c1.235-.036 1.603.464 2.956.87 1.34.404 3.145 1.011 5.186 1.237 2.706.286 4 .322 4.297.286.736-.107 2.456.024 3.572.81 1.579 1.108 1.151 3.525-.45 4.978-1.449 1.322-6.813.369-9.828-1.453-3.37-2.036-6.552-3.751-7.287-3.977-.748-.239-1.923-.405-1.923-.405s.855-2.25 3.466-2.334l.011-.012z",
    fill: "#FF9E78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.221 42.231c.724.179 1.389.238 1.733.274-.166-.06-.273-.107-.273-.107.19-.131.226-.286.202-.417-.13.369-.938.238-1.614.071-.985-.238-1.662.131-2.208.429l-.107.06c-.546.285-1.008.416-1.008.416.047.155.652-.035 1.092-.262l.106-.06c.546-.297 1.163-.63 2.077-.404zM50.812 43.315c.439.06.89.178 1.103.238 0 0-.07-.084-.106-.095h-.012s.142-.072.142-.298h-.024c-.166.179-.724.048-1.068 0-.581-.083-1.768-.143-2.326-.06-.463.072-2.386.75-2.006.822.154.036 1.602-.583 2.03-.643.486-.072 1.637-.024 2.267.06v-.024zM51.025 43.886c-.083-.024-.154-.012-.249 0-.119 0-.25.012-.427-.024-.404-.083-1.223.143-1.674.286-.546.167-1.91.715-1.614.786.166.036 1.151-.464 1.662-.619.748-.226 1.317-.334 1.59-.274.202.036.356.036.475.024h.202c.285.024.142.464.13.476a.969.969 0 00.06-.214c.45-.036.795-.25.807-.512-.107.286-.796.119-.95.083l-.012-.012z",
    fill: "#F28C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.57 45.672c.012.072-.202.465-.202.465s-2.659.178-2.872 2.393c-.285 2.906 2.469 3.692 2.528 3.728.06.035.878.119.878.119l-.06.44s-2.86.846-4.616-.44c-1.757-1.286-1.685-4.275.202-5.93 1.887-1.668 4.142-.786 4.142-.786v.011z",
    fill: "#2E333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.393 51.984c1.602-1.453 2.03-3.87.451-4.978-1.115-.786-2.836-.917-3.572-.81-.119.012-.416 0-.902 0 4.89.953 4.427 4.454 1.507 4.87-2.92.418-11.94-4.786-15.073-5.417-.558-.108.534-1.596 2.29-1.632.89-.024 1.27.095 1.294.107-.462-.202-.878-.333-1.542-.321-2.6.083-3.466 2.334-3.466 2.334s1.163.167 1.923.405c.724.226 3.916 1.94 7.287 3.977 3.003 1.822 8.379 2.763 9.827 1.453l-.024.012z",
    fill: "#F28C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.18 46.196s.724-.38 1.02-.512c.309-.13 4.25-.833 5.199 2.24.95 3.071-1.424 5.786-4.914 5.655-2.184-.083-2.279-1.298-2.279-1.298l.808.12s4.462.666 4.96-2.525c.5-3.191-4.794-3.68-4.794-3.68z",
    fill: "#2E333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.886 53.472c-.962-.06-2.113-.274-2.362-.464-.13-.095-.285-.346-.392-.62l-.344-.035c.048.13.309.726.546.905.368.274 1.733.512 2.552.572v-.358z",
    fill: "#2E333D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.521 24.5l-.154 3.143s.605-.524.843-1.262c.225-.738.546-2.215.083-2.715s-.76.834-.76.834h-.012zM35.632 25.381l.32 2.989s-.629-.298-.89-.988c-.25-.68-.688-2.073-.498-2.644.178-.572 1.068.631 1.068.631v.012z",
    fill: "#EA966C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.386 21.451c.023.084-.048.167-.036.262.166 1.036 1.092 7.014 1.543 7.812.498.905 3.026 3.227 4.7 3.049 1.673-.18 3.655-2.585 3.916-3.513.155-.548.843-7.384.772-8.634 0-.083-1.816-4.299-6.326-3.465-3.525.369-4.973 3.287-4.557 4.501l-.012-.012z",
    fill: "#FF9E78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.86 23.428c-.178.083-1.982.143-2.35.155-.558.024-.783.214-.783.214s.06-.548.51-.679c.463-.142 2.552-.31 2.67-.178.12.143.131.405-.047.488z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M41.293 30.24c-.51.19-1.151.202-1.65.142 0 0 .226.262.855.239.57-.024.795-.37.795-.37v-.012z",
    fill: "#BA6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.937 23.202c.178.047 1.804-.238 2.136-.298.51-.083.736.048.736.048s-.154-.524-.593-.572c-.44-.047-2.35.19-2.421.345-.072.155-.036.417.142.465v.012z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M42.361 28.632c-.06.083-.926.31-1.946.417-.879.095-1.994-.06-2.101-.072-.107 0-.178-.405.024-.071.06.095.925-.095 2.017-.203 1.092-.095 1.888.167 1.935-.143.035-.214.142-.047.06.072h.011z",
    fill: "#BA6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.934 28.763L38.682 29s.522.81 1.721.714c1.175-.083 1.531-.952 1.531-.952z",
    fill: "#F1F1F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.198 24.738c-.76.155-1.103.69-1.103.69s-.06.108 1.34.155c1.128-.083 1.425-.178 1.425-.262-.012-.214-.688-.774-1.65-.583h-.012z",
    fill: "#EFEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.993 24.976c-.035-.286-.32-.5-.617-.464a.531.531 0 00-.474.607c.035.298.32.5.617.464a.531.531 0 00.474-.607z",
    fill: "#667149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.84 24.988a.397.397 0 00-.44-.322.377.377 0 00-.332.43.38.38 0 00.439.32.377.377 0 00.332-.428z",
    fill: "#1B1B1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.982 24.81c0-.084-.095-.144-.178-.132-.095 0-.155.095-.143.179 0 .095.095.143.178.13.095 0 .154-.082.143-.178z",
    fill: "#EBE7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.293 24.357c1.59-.12 1.567.964 1.567.964s-.498-.75-1.602-.63c-.677.083-1.152.738-1.152.738s0-.989 1.2-1.072h-.013z",
    fill: "#CA7F6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.293 24.583c1.377-.179 1.555.738 1.555.738s-.593-.762-1.555-.56c-.878.18-1.199.668-1.199.668s.024-.691 1.211-.846h-.012z",
    fill: "#3C2A25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.48 24.202a1.704 1.704 0 011.234.44s0 .18-1.27.465c-1.222.203-1.46.107-1.471.024-.024-.31.712-.905 1.495-.929h.012z",
    fill: "#EFEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.744 24.595a.546.546 0 01.51-.583c.31-.024.57.19.594.488a.546.546 0 01-.51.583.54.54 0 01-.594-.488z",
    fill: "#667149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.91 24.583a.395.395 0 01.356-.417.38.38 0 01.428.346c.023.202-.143.393-.356.405a.387.387 0 01-.428-.346v.012z",
    fill: "#1B1B1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.551 24.345c0-.083.06-.167.143-.167.095 0 .166.06.178.143 0 .083-.06.155-.155.167-.095 0-.166-.06-.178-.143h.012z",
    fill: "#EBE7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.278 23.869c-1.507.166-1.294 1.262-1.294 1.262s.333-.846 1.448-.965c.689-.071 1.294.477 1.294.477s-.13-.905-1.448-.762v-.012z",
    fill: "#CA7F6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.314 24.095c-1.377.202-1.318 1.036-1.318 1.036s.392-.81 1.413-.881c.902-.072 1.33.393 1.33.393s-.203-.715-1.413-.536l-.012-.012z",
    fill: "#3C2A25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.05 16.83s-.82-1.535-1.947-1.666c-1.127-.131-3.643.357-5.412 1.679-1.317.988-2.338 2.346-2.136 4.227.214 2 1.614 5.514 1.614 5.514s-.475-3.68 0-4.442c.154-.31.225-.631 4.012-1.393 2.92-.608 3.477-2.668 3.477-2.668l.404-1.262-.012.012z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.05 16.83s2.528.549 2.706 2.263c.202 1.846-.938 7.407-.938 7.407s.19-4.537-.06-5.81c-.272-1.442-2.61-1.68-2.61-1.68l.902-2.18z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.747 25.429s-.083 1.119-.035 1.881c.023.417-.178.643-.38.69 0 0 .83.132.95-.654.082-.524-.404-1.096-.535-1.917z",
    fill: "#A5644F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.893 27.93s-.796-.275-.665-.036c.13.25.665.035.665.035z",
    fill: "#975238"
  })))));
}

export { SvgLoadOwnerIcon as ReactComponent };
//# sourceMappingURL=load_owner_icon.svg.js.map
